import { useDispatch } from "react-redux";
import {
  setFromDate, setToDate, setCode, setCodes,
  setCodInvoiceModel, setCouponType,
  setInvoiceType, setEntryExit, resetAll,
} from "..";
import { CodInvoiceModel, InvoiceType } from "../../../constants/const";

export const useOfmFiltersActions = () => {
  const dispatch = useDispatch();
  return {
    setFromDate: (d: Date | null) => dispatch(setFromDate(d)),
    setToDate:   (d: Date | null) => dispatch(setToDate(d)),
    setCode:     (v?: string)     => dispatch(setCode(v)),
    setCodes:    (arr: string[])  => dispatch(setCodes(arr)),
    setCodInvoiceModel: (v?: CodInvoiceModel) => dispatch(setCodInvoiceModel(v)),
    setCouponType:      (v?: CodInvoiceModel) => dispatch(setCouponType(v)),
    setInvoiceType:     (v?: InvoiceType)   => dispatch(setInvoiceType(v)),
    setEntryExit:       (v?: InvoiceType)   => dispatch(setEntryExit(v)),
    reset: () => dispatch(resetAll()),
  };
};
